/**
 * Comparator shared by the client-side table sorts. It never applies the
 * direction sign itself, so each table decides whether a missing value follows
 * the direction or stays pinned to one end.
 */

export type SortValue = string | number | null

export function compareSortValues(va: SortValue, vb: SortValue): number {
  if (va == null && vb == null) return 0
  if (va == null) return 1
  if (vb == null) return -1
  if (typeof va === 'number' && typeof vb === 'number') return va - vb
  return String(va).localeCompare(String(vb), 'en-IN', { numeric: true })
}
